import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
} from '@mui/material';
import { useState, useContext } from 'react';
import { Trans } from 'react-i18next';

import EditWorkTimeModelTable from '../shared/EditWorkTimeModelTable';
import api from '../../api';
import {
    setUser,
} from '../../context/actions';
import { Context } from '../../context/context';
import FlexTimeConfigForm from '../shared/FlexTimeConfigForm';

const STAGES = {
    Info: 0,
    StartValue: 1,
    WorkTimeModel: 2,
};

function FlexTimeWizard({ open, onClose, onStart, onSubmit }) {
    const [{ user }, dispatch] = useContext(Context);
    const [stage, setStage] = useState(STAGES.Info);
   
    const handleChangeWorkTimeModel = (user) => {
        api.updateUser(user.id, user).then(res => {
            dispatch(setUser(res));
        });
    };

    return (
        <>
            <Dialog open={open}>
                {stage === STAGES.Info &&
                    <>
                        <DialogTitle>
                            <Trans i18nKey='wizardTitel' ns='flexTimeWizard'>
                                Arbeitszeitkonto?
                            </Trans>
                        </DialogTitle>
                        <DialogContent>
                            <Trans i18nKey='info' ns='flexTimeWizard'>
                                Zusätzlich zur täglichen Dokumentation deiner Arbeitszeiten kann SCEDAS Timekeeper dich bei der Erfassung von Mehrarbeits- bzw. Minusstunden unterstützen. Richte dazu ein Arbeitszeitkonto ein.
                            </Trans>
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={onClose}>
                                <Trans ns='flexTimeWizard' i18nKey='skip'>Überspringen</Trans>
                            </Button>
                            <Button variant='contained' onClick={() => { onStart(); setStage(STAGES.StartValue); }}>
                                <Trans i18nKey='einrichten' ns='flexTimeWizard'>Arbeitszeitkonto einrichten</Trans>
                            </Button>
                        </DialogActions>
                    </>
                }
                {stage === STAGES.StartValue &&
                    <>
                        <DialogTitle>
                            <Trans i18nKey='wizardTitel2' ns='flexTimeWizard'>
                                Startwert deines Arbeitszeitkontos
                            </Trans>
                        </DialogTitle>
                    <DialogContent>
                        <FlexTimeConfigForm />
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={() => setStage(STAGES.Info)}>
                                <Trans ns='flexTimeWizard' i18nKey='back'>Zurück</Trans>
                            </Button>
                            <Button variant='contained' onClick={() => setStage(STAGES.WorkTimeModel)}>
                                <Trans i18nKey='next' ns='flexTimeWizard'>Weiter</Trans>
                            </Button>
                        </DialogActions>
                    </>
                }
                {stage === STAGES.WorkTimeModel &&
                    <>
                        <DialogTitle>
                            <Trans i18nKey='wizardTitel3' ns='flexTimeWizard'>
                                Dein Arbeitszeitmodell
                            </Trans>
                        </DialogTitle>
                        <DialogContent>
                            <EditWorkTimeModelTable user={user} onChange={handleChangeWorkTimeModel} />
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={() => setStage(STAGES.StartValue)}>
                                <Trans ns='flexTimeWizard' i18nKey='back'>Zurück</Trans>
                            </Button>
                            <Button variant='contained' onClick={onSubmit}>
                                <Trans i18nKey='done' ns='flexTimeWizard'>Fertig</Trans>
                            </Button>
                        </DialogActions>
                    </>
                }
            </Dialog>
        </>
    )

}

export default FlexTimeWizard
